<template>
    <div>
        <h3 class="font-bold text-xl mb-4">{{ $t("verifyEmail") }}</h3>
        <p class="mb-3">
            {{ $t("linkWasSent") }}
        </p>
        <p class="mb-1">
            {{ $t("didntGetEmail") }}
        </p>
        <p>
            {{ $t("checkSpam") }}
        </p>
        <div class="mt-3">
            <k-button @click.native.prevent="sendCode">
                {{ $t("resendVerification") }}
            </k-button>
        </div>
        <div class="mt-10" v-if="verificationToken">
            <router-link class="text-gray-500 text-sm"
                         :to="{name: 'complete-email-verification', params: {token: verificationToken}}">
                {{ $t("confirmVerification") }}
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                verificationToken: null,
                validation: {
                    fieldErrors: {}
                }
            }
        },
        async mounted() {
            await this.sendCode();
        },
        methods: {
            async sendCode() {
                const resp = await this.$post('registration/send-verification-email')
                // for testing only, on production will be empty
                this.verificationToken = resp.verificationToken;
            },
            fieldError(field) {
                return this.validation.fieldErrors[field];
            },
        }
    }
</script>

